var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3332 16C29.3332 23.3638 23.3636 29.3334 15.9998 29.3334C8.63604 29.3334 2.6665 23.3638 2.6665 16C2.6665 8.63622 8.63604 2.66669 15.9998 2.66669C23.3636 2.66669 29.3332 8.63622 29.3332 16ZM13.4348 12.5011C13.5022 12.6621 13.6009 12.8081 13.7252 12.9307L16.8278 16.0067L13.7372 19.0693C13.6129 19.1919 13.5142 19.3379 13.4468 19.499C13.3795 19.66 13.3448 19.8328 13.3448 20.0073C13.3448 20.1819 13.3795 20.3547 13.4468 20.5157C13.5142 20.6768 13.6129 20.8228 13.7372 20.9453C13.9893 21.1945 14.3294 21.3342 14.6838 21.3342C15.0383 21.3342 15.3784 21.1945 15.6305 20.9453L19.5705 17.0387C19.7068 16.9036 19.8149 16.7428 19.8887 16.5657C19.9625 16.3886 20.0005 16.1986 20.0005 16.0067C20.0005 15.8148 19.9625 15.6248 19.8887 15.4477C19.8149 15.2705 19.7068 15.1098 19.5705 14.9747L15.6172 11.0547C15.3651 10.8059 15.0253 10.6664 14.6712 10.6664C14.3171 10.6664 13.9772 10.8059 13.7252 11.0547C13.6009 11.1772 13.5022 11.3233 13.4348 11.4843C13.3675 11.6453 13.3328 11.8181 13.3328 11.9927C13.3328 12.1672 13.3675 12.34 13.4348 12.5011Z",
    fill: "#091E42",
    fillOpacity: 0.77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCircle);
export default __webpack_public_path__ + "static/media/chevron-right-circle.126155df1adbf2e978bae823c3559cb6.svg";
export { ForwardRef as ReactComponent };